import React from "react";
import { BackwardOutlined } from "@ant-design/icons";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useNavigate } from "react-router-dom";
const CustomBackButton = ({ children, style,onClick, ...rest }) => {
  const navigate = useNavigate();
  return (
    <>
      <button
        className="flex items-center bg-[transparent] border-none"
        style={{
          ...style,
        }}
        onClick={onClick?onClick:() => navigate(-1)}
      >
        <ArrowBackIosIcon style={{ fontSize: "18px", color:"gray" }} />
        {/* <strong>{children + " posts details" || "Back"}</strong> */}
        <strong className="text-[gray]">{children?children: "Back"}</strong>

      </button>
    </>
  );
};

export default CustomBackButton;
